import styled from 'styled-components';
import { FlexContainer } from '@taxdown/piccolo-web';
import { boxShadow, flexCenter, pxToRem } from 'Styles/utils/utils';
import { DESKTOP_EXTRA_SMALL_WIDTH, MOBILE_WIDTH } from 'Styles/variables/sizes';
import { InvalidBox as InvalidBoxComponent } from './components';

export const InvalidBox = styled(InvalidBoxComponent)``;

export const TrushArea = styled.div`
  display: block;
  position: absolute;
  top: 0;
  left: calc(100% - ${pxToRem(20)});
  width: ${pxToRem(32)};
  height: 100%;
  border-radius: 14px;
  ${flexCenter}
  svg {
    cursor: pointer;
    path {
      stroke: ${({ theme: { colors } }) => colors.red_1};
    }
  }

  @media screen and (min-width: ${DESKTOP_EXTRA_SMALL_WIDTH}) {
    width: ${pxToRem(80)};
    left: calc(100% - ${pxToRem(68)});
  }
`;

export const SummaryIcon = styled.div`
  margin-right: ${pxToRem(20)};
  display: flex;
  flex-direction: column;
  img {
    width: ${pxToRem(60)};
    height: auto;
  }
  ${({ hasIcon }) =>
    !hasIcon &&
    `
      margin-right: 0;
  `}
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    display: none;
  }
`;

export const CardContent = styled.div`
  width: 90%;
  padding: ${pxToRem(30)};
  border-radius: 14px;
  background: ${({ theme: { colors } }) => colors.white};
  ${boxShadow}

  @media screen and (min-width: ${DESKTOP_EXTRA_SMALL_WIDTH}) {
    width: 85%;
  }
`;

export const StyledContainer = styled(FlexContainer)`
  @media screen and (max-width: ${DESKTOP_EXTRA_SMALL_WIDTH}) {
    display: flex;
    flex-direction: column;
  }
`;

export const DeleteAction = styled.button`
  cursor: pointer;
  padding: 0;
  margin-top: auto;
  padding-top: ${pxToRem(16)};
  display: block;
  align-self: flex-start;
  @media screen and (min-width: ${DESKTOP_EXTRA_SMALL_WIDTH}) {
    display: none;
  }
`;

export const SummaryCardContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: ${pxToRem(20)};
  position: relative;
  transition: 0.3s ease-out;
  z-index: 2;
`;
